import React from 'react'
import { Text, useTheme } from 'react-native-paper'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'
import Color from 'color'
import { Container } from './Container'

export const TextTile = ({ style, text, textStyle, children, hideBackground, ...props }) => {
  const { colors: { primary } } = useTheme()

  return <Container style={composeStyle({
    padding: 20,
    borderRadius: 20,
    marginBottom: 12
  }, !hideBackground && {
    backgroundColor: Color(primary).alpha(0.2).rgb().string()
  }, style)}  {...props}>
    {
      text && <Text style={composeStyle({
        fontSize: 15
      }, textStyle)}>{text}</Text>
    }
    {children}
  </Container>
}
